
/**
 * Normalizes an offset to be within the range [0, max-1]
 * @param offset The offset to normalize
 * @param max The maximum value (exclusive)
 * @returns A normalized offset between 0 and max-1
 */
export default function normalizeCircularOffset(offset: number, max: number): number {
  return ((offset % max) + max) % max
}